module.exports = __webpack_public_path__ + "img/cleanup6-7-8-2021.1abd3225.jpg";